export abstract class Component {
    protected element: HTMLElement;
    protected unsubscribers: (() => void)[] = [];
    
    constructor(element: HTMLElement) {
        this.element = element;
    }
    
    protected abstract render(): void;
    
    destroy(): void {
        this.unsubscribers.forEach(unsub => unsub());
        this.unsubscribers = [];
    }
}